/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/DeliverySystemLink.js
 */

import React from 'react';
import { Link } from 'react-router-dom';

const getLink = (data) => `/search?query=${data.deliverySystem}:${data.id}`;

const DeliverySystemLink = ({ data, type }) => {
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <Link className="Link" to={getLink(data)}>
          <div className="Type">Delivery System</div>
          <div className="Value">{`${data.deliverySystem} : ${data.id}`}</div>
        </Link>
      </div>
      <div className="SummaryLink">
        <Link className="Link" to={getLink(data)}>
          {getLink(data)}
        </Link>
      </div>
      <div className="SummaryData">
        <p>
          {data.deliverySystem} Account Status:{' '}
          {data.status ? data.status : 'Not available'}
        </p>
        <p>
          {data.customer && data.customer.name
            ? `Customer: ${data.customer.name} (${data.customer.id})`
            : data.customer && data.customer.id
            ? `Customer Id: ${data.customer.id}`
            : 'No customer is paying for this service'}
        </p>
      </div>
    </div>
  );
};

export default DeliverySystemLink;
